import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { DotsSixVerticalIcon } from '@phosphor-icons/react'

import * as Styles from './styles'

const SortableWrapper = ({ id, dragging, isEditable, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id, disabled: !isEditable })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <Styles.Container dragging={dragging} ref={setNodeRef} style={style}>
      {isEditable && <DotsSixVerticalIcon size={24} id="draggable-icon" {...attributes} {...listeners} />}
      {children}
    </Styles.Container>
  )
}

export default SortableWrapper
